/**
 * Formats an ISO UTC timestamp to local browser timezone
 * @param {string} isoString - ISO 8601 UTC timestamp string (e.g., "2024-12-14T08:28:45Z")
 * @returns {string} Formatted date string in format "DD MMM YYYY, HH:mm" (24-hour format)
 */
export const formatEventTimestamp = (isoString) => {
  if (!isoString) return '';

  const date = new Date(isoString);

  // Check if date is valid
  if (isNaN(date.getTime())) {
    return '';
  }

  // Format: DD MMM YYYY, HH:mm (24-hour format)
  const day = String(date.getDate()).padStart(2, '0'); // Local date
  const month = date.toLocaleDateString('en-US', { month: 'short' }); // Local month
  const year = date.getFullYear(); // Local year
  const hours = String(date.getHours()).padStart(2, '0'); // Local hours (0-23)
  const minutes = String(date.getMinutes()).padStart(2, '0'); // Local minutes

  return `${day} ${month} ${year}, ${hours}:${minutes}`;
};
